import { combineReducers } from 'redux';
import { applicationsListReducer } from './reducers/application-list-reducer';

export default combineReducers({
  applicationsListReducer,
});
